declare var swal: any;
import { KeyValuePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbDateStruct, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/octet-stream';//'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'; 
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ActorService } from '../../../services/actor.service';
import { SpinnerService } from '../../../services/spinner.service';

import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

import { GenericProcPostRequest, InstantReportRequest, GenericInstantReportRequest, DataSetModel } from '../../../models/actor/actor';
const isNullOrUndefined = (val: any) => val === null || val === undefined;
//import { BaseClass } from 'src/app/ncs/models/master/mastermodel';

@Component({
  selector: 'excelreporting',
  templateUrl: './excelreporting.component.html',
  styleUrls: ['./excelreporting.component.css']
})
export class ExcelReportingComponent implements OnInit {

  public ActorCode: number = 1;
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  SelectedFromDate: NgbDateStruct;
  SelectedToDate: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  public ApiResData: ApiResponseModel;
  mreq: GenericProcPostRequest;
  selectedReport: string;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private actorservice: ActorService,
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService,
    private spinner: NgxSpinnerService,
    keyvalue: KeyValuePipe) {

    this.mreq = new GenericProcPostRequest();
    this.mreq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.mreq.ConditionalOperator = 9000;
    this.mreq.QueryData = "";
  }

  ngOnInit(): void {
    this.LoadReportsByModule();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
  }

  LoadReportsByModule() {
    this.mreq.QueryData = "Billing "//this.selectedReport;
    this.GetReportModulesListController();
  }

  ReportChanged(data: any) {
    //alert(data);
    //alert(data.DisplayName);
    //this.spinner.show();
    this.mreq.QueryData = data;
    this.ReportsList = null;
    this.GetReportModulesListController();
  }
  ReportsList: ReportItem[];
  GetReportModulesListController() {
    this.StartRefreshing();
    //this.actorservice.generic_proc_post(this.mreq)
    this.actorservice.generic_proc_post_large_data(this.mreq)
      .subscribe((result) => {
        //alert(result);
        this.ApiResData = result;
        //alert(this.ApiResData.Result);
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData.Result);
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.ReportsList = JSON.parse(data);//this.ApiResData.Result);
          //this.ReportsList = this.ApiResData.Result;
          // alert(this.modules.length);
          //this.pdata = this.CurrentStoreLocationMaterialsController;
          //this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  rr: InstantReportRequest = new InstantReportRequest();
  SelectedReportItem: ReportItem;

  SelectedReport(r: ReportItem) {
    this.SelectedReportItem = null;
    this.SelectedReportItem = r;
    if (isNullOrUndefined(r.IsEmployee))
      this.rr.IsEmployee = false;
    else
      this.rr.IsEmployee = r.IsEmployee;
    this.rr.IsFacility = r.IsFacility;
    this.rr.IsFromDate = r.IsFromDate;
    if (isNullOrUndefined(r.IsPatientFormatted))
      this.rr.IsPatientFormatted = false;
    else
      this.rr.IsPatientFormatted = r.IsPatientFormatted;
    this.rr.IsToDate = r.IsToDate;
    this.rr.ProcedureName = r.ProcedureName;
    this.rr.ReportName = r.ReportName;
    this.rr.VariableList = r.VariableList;

    this.rr.PatientFormatted = "";
    this.rr.Employee = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.rr.Facility = this.SelectedFacilityCode;
    //  alert(this.parserFormatter.format(this.SelectedFromDate));
    this.rr.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.rr.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));

  }
  SelectedFacilityCode: number;
  Roleassign(d: any) {
  }
  ReportsData: string;
  //OnGenerate() {
  //  var newgenericreq = new GenericInstantReportRequest();
  //  var gReq: GenericProcPostRequest = new GenericProcPostRequest();
  //  newgenericreq.ConditionalOperator = 9090;

  //  var r = this.SelectedReportItem;
  //  if (isNullOrUndefined(r.IsEmployee))
  //    newgenericreq.IsEmployee = false;
  //  else
  //    newgenericreq.IsEmployee = r.IsEmployee;

  //  newgenericreq.IsFacility = r.IsFacility;
  //  newgenericreq.IsFromDate = r.IsFromDate;
  //  if (isNullOrUndefined(r.IsPatientFormatted))
  //    newgenericreq.IsPatientFormatted = false;
  //  else
  //    newgenericreq.IsPatientFormatted = r.IsPatientFormatted;
  //  newgenericreq.IsToDate = r.IsToDate;
  //  newgenericreq.ProcedureName = r.ProcedureName;
  //  newgenericreq.ReportName = r.ReportName;
  //  newgenericreq.VariableList = r.VariableList;

  //  newgenericreq.PatientFormatted = "";
  //  newgenericreq.Employee = AppData.Instance().UserLoginDetails.EmployeeCode;
  //  newgenericreq.Facility = this.SelectedFacilityCode;
  //  // alert(this.parserFormatter.format(this.SelectedFromDate));
  //  newgenericreq.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
  //  newgenericreq.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
  //  newgenericreq.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  //  var str = JSON.stringify(newgenericreq);

  //  gReq.ConditionalOperator = 9090;
  //  gReq.QueryData = str;
  //  gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;


  //  this.StartRefreshing();


  //  //this.actorservice.generic_proc_post(this.mreq)
  //  this.actorservice.generic_proc_post_large_data(gReq)
  //    .subscribe((result) => {
  //   //   alert(result);
  //      this.ApiResData = result;
  //      //alert(this.ApiResData.Result);
  //      //alert(this.ApiResData.ErrorData);
  //      if (!this.ApiResData.hasError) {
  //        //alert(this.ApiResData.Result);
  //        var data: string = this.ApiResData.Result.join("");
  //     //   alert(data);
  //        this.ReportsData = JSON.parse(data);//this.ApiResData.Result);
  //        // alert(this.modules.length);
  //        //this.pdata = this.CurrentStoreLocationMaterialsController;
  //        //this.spinner.hide();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );


  //  //this.actorservice.GetInstantReportServiceController(this.rr)
  //  //  .subscribe((result) => {
  //  //    var link = document.createElement('a');
  //  //    link.href = window.URL.createObjectURL(result);
  //  //    link.download = "Report.xlsx";
  //  //    link.click();

  //  //    var filename = Headers['x-filename'];
  //  //    var contentType = Headers['content-type'];

  //  // var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  //  //    var blob = new Blob([result.FileStream._buffer], {
  //  //      type: 'arraybuffer'
  //  //    });
  //  //    var binaryData = [];
  //  //    binaryData.push(result);
  //  //    var url = window.URL.createObjectURL(
  //  //      new Blob(binaryData,
  //  //        { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

  //  //    let pwa = window.open(url, "_blank");
  //  //    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
  //  //      //alert('Please disable your Pop-up blocker and try again.');
  //  //    }

  //  //  this.downLoadFile2(result, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');//"application/ms-excel")
  //  //    this.saveAsExcelFile(result.FileStream, '1234.xlsx');
  //  //    this.saveAsExcelFile(result.FileStream._buffer, '12345.xlsx');
  //  //  }

  //  //  );



  //}
  OnGenerate() {
    this.spinner.show();
    //alert("calling server file download..")
    var r = this.SelectedReportItem;
    if (isNullOrUndefined(r.IsEmployee))
      this.rr.IsEmployee = false;
    else
      this.rr.IsEmployee = r.IsEmployee;
    this.rr.IsFacility = r.IsFacility;
    this.rr.IsFromDate = r.IsFromDate;
    if (isNullOrUndefined(r.IsPatientFormatted))
      this.rr.IsPatientFormatted = false;
    else
      this.rr.IsPatientFormatted = r.IsPatientFormatted;
    this.rr.IsToDate = r.IsToDate;
    this.rr.ProcedureName = r.ProcedureName;
    this.rr.ReportName = r.ReportName;
    this.rr.VariableList = r.VariableList;

    this.rr.PatientFormatted = "";
    this.rr.Employee = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.rr.Facility = this.SelectedFacilityCode;
    // alert(this.parserFormatter.format(this.SelectedFromDate));
    this.rr.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.rr.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.rr.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetInstantReportServiceController2(this.rr)
      .subscribe((result) => {
        // result.Result  is a dataset now..
        this.ApiResData = result;
        this.ReportsData = this.ApiResData.Result;
        this.ReportDataModel = JSON.parse(this.ApiResData.Result);
        this.spinner.hide();
        //alert(this.ReportDataModel);       
        //alert(this.ReportDataModel.DataTables);
        //alert(this.ReportDataModel[0].Name);
      });
  }
  ReportDataModel: any;// DataSetModel;
  OnNavigate() {
    this.spinner.show();
    //alert("calling server file download..")
    var r  =     this.SelectedReportItem ;
    if (isNullOrUndefined(r.IsEmployee))
      this.rr.IsEmployee = false;
    else
      this.rr.IsEmployee = r.IsEmployee;
    this.rr.IsFacility = r.IsFacility;
    this.rr.IsFromDate = r.IsFromDate;
    if (isNullOrUndefined(r.IsPatientFormatted))
      this.rr.IsPatientFormatted = false;
    else
      this.rr.IsPatientFormatted = r.IsPatientFormatted;
    this.rr.IsToDate = r.IsToDate;
    this.rr.ProcedureName = r.ProcedureName;
    this.rr.ReportName = r.ReportName;
    this.rr.VariableList = r.VariableList;

    this.rr.PatientFormatted = "";
    this.rr.Employee = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.rr.Facility = this.SelectedFacilityCode;
   // alert(this.parserFormatter.format(this.SelectedFromDate));
    this.rr.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.rr.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
    this.rr.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetInstantReportServiceController(this.rr)
      .subscribe((result) => {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(result);
        link.download = this.rr.ProcedureName + "_Report.xlsx";
        link.click();
        this.spinner.hide();
        //alert(result);
        var filename = Headers['x-filename'];
        var contentType = Headers['content-type'];

        //var linkElement = document.createElement('a');

        //{
        var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        var blob = new Blob([result.FileStream._buffer], {
          type: 'arraybuffer'
        });
        var binaryData = [];
        binaryData.push(result);
        var url = window.URL.createObjectURL(
          new Blob(binaryData,
            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

        //var url = window.URL.createObjectURL(blob);
        let pwa = window.open(url, "_blank");
        if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
          //alert('Please disable your Pop-up blocker and try again.');
        }

    //    this.downLoadFile(result, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');//"application/ms-excel")
        this.downLoadFile2(result, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');//"application/ms-excel")
        this.saveAsExcelFile(result.FileStream, '1234.xlsx');
        this.saveAsExcelFile(result.FileStream._buffer, '12345.xlsx');
        
      }
        
      //.subscribe((res) => {
      //  alert(res);
      //  this.downLoadFile(res, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');//"application/ms-excel")
      //  this.downLoadFile2(res, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');//"application/ms-excel")

      //  //   const a = document.createElement('a');
      //  //   a.setAttribute('type', 'hidden');
      //  //a.href = URL.createObjectURL(res.data);
      //  //a.download = this.rr.ProcedureName + '.xlsx';
      //  //   a.click();
      //  //   a.remove();
       

      //    //const blob = new Blob([res], { type: 'text/csv' }); // you can change the type
      //    //const url = window.URL.createObjectURL(blob);
      //    //window.open(url);
        


      // // alert(res);
      // // var downloadUrl = URL.createObjectURL(res);
      // // alert(downloadUrl);
      // // window.open(downloadUrl, "_blank");
      // //// alert(res.Result);
      // // var m: Response = res.Result;

      //  //const blob: any = new Blob([m.blob() as unknown as BlobPart],
      //  //  { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      //  //let link = document.createElement("a");

      //  //if (link.download !== undefined) {
      //  //  let url = URL.createObjectURL(blob);
      //  //  link.setAttribute("href", url);
      //  //  var fileName = fileName || m.headers.get('content-disposition').split(';')[0];
      //  //  alert(fileName);
      //  //  link.setAttribute("download", fileName);
      //  //  document.body.appendChild(link);
      //  //  link.click();
      //  //  document.body.removeChild(link);
      //  //}
      //}
      );
       // this.downloadFile(res.Result);
        //window.open("" ,"_blank");
     // })
    //window.open("http://google.com" + this.SelectedReportItem.ReportCode, "_blank");


  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  } 
  downLoadFile2(data:any, type: string) {
    //let byteCharacters = atob(data);
    //let byteNumbers = new Array(byteCharacters.length);
    //for (var i = 0; i < byteCharacters.length; i++)
    //  byteNumbers[i] = byteCharacters.charCodeAt(i);

    //let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([data], { type: type });

 //   alert(data);
    //let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    //  let url = window.URL.createObjectURL(data);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      //alert('Please disable your Pop-up blocker and try again.');
    }
  }
  downLoadFile(data: any, type: string) {
    //let byteCharacters = atob(data);
    //let byteNumbers = new Array(byteCharacters.length);
    //for (var i = 0; i < byteCharacters.length; i++)
    //  byteNumbers[i] = byteCharacters.charCodeAt(i);

    //let byteArray = new Uint8Array(byteNumbers);
    let blob = data;//new Blob([data], { type: type });

   // alert(data);
    //let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
  //  let url = window.URL.createObjectURL(data);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      //alert('Please disable your Pop-up blocker and try again.');
    }
  }
  downloadFile(data: Response) {
    var fileName = fileName || data.headers.get('content-disposition').split(';')[0];
   // alert(fileName);
    //const blob = new Blob([data.blob], { type: 'application/octet-stream' });
    //const url = window.URL.createObjectURL(blob);
    //window.open(url, "_blank");
  }
  DecrementDate() {
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
  }
  IncrementDate() {
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
  }
}


export class ReportItem {
  ReportName: string;
  ReportCode: number;
  VariableList: string;
  IsFacility: Boolean;
  IsFromDate: Boolean;
  IsToDate: Boolean;
  IsEmployee: Boolean;
  IsPatientFormatted: Boolean;
  ProcedureName: string;

}


